import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DocumentModel } from '@data-layer/models/documents';
import { enumDocumentState } from '@data-layer/enums/documents';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { takeUntil } from 'rxjs/operators';
import { CompaniesService } from '@services/companies.service';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'company-duties-payment-form',
  templateUrl: './company-duties-payment-form.component.html',
  styleUrls: ['./company-duties-payment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyDutiesPaymentFormComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;

  @Input() public isShowDescription: boolean = false;
  @Input() public punDocument: DocumentModel;
  @Input() public isLoadingCompanyPun: boolean;

  @Output() public uploadDocument: EventEmitter<File> = new EventEmitter<File>();
  @Output() public deleteDocument: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
  @Output() public updateDocumentState: EventEmitter<enumDocumentState> = new EventEmitter<enumDocumentState>();

  public payerUnitNumberErrors: IErrorForm = {
    required: 'FORM_ERROR.REQUIRED',
    maxlength: 'FORM_ERROR.MAX_LENGTH',
    minlength: 'FORM_ERROR.MIN_LENGTH',
  };
  private destroy$: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private companiesService: CompaniesService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.companiesService.companyUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => this.cdr.markForCheck());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }
}
